if(!customElements.get('search-drawer')) {
  customElements.define(
    "search-drawer",
    class SearchDrawer extends Drawer {
      show(opener) {
        super.show(opener);

        this.recommendationByHistory = this.querySelector("recommendation-by-history");
        this.recommendationByHistory?.showContent();
      }

      hide() {
        super.hide();

        this.recommendationByHistory?.abortFetch();
      }
    },
  );
}